<template>
<main class="container-1-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <h2>{{user.firstname + ' ' + user.lastname}}</h2>
    </div>

    <div class="container-body">

        <template v-if="!generatedPassword">
            <span>¿Confirmar creación de una contraseña temporal?</span>
            <br>
            <span>La contraseña actual del usuario será invalidada. En el próximo inicio de sesión, el usuario deberá crear una nueva contraseña.</span>
            <br><br>
            <button class="btn btn-danger" style="margin-right: 1em;" v-on:click="generateTempPassword()" :disabled="submitting">Sí</button>
            <button class="btn btn-secondary" v-on:click="onClickGoBack()" :disabled="submitting">No</button>
        </template>

        <template v-else>
            <strong>Contraseña temporal creada</strong>
            <br>
            <span>Entréguela al usuario. Solo se mostrará una vez.</span>
            <br><br>
            <div class="temp-password-row">
                <code class="temp-password-code">{{generatedPassword}}</code>
                <button class="btn btn-secondary" v-on:click="copyToClipboard()">Copiar</button>
            </div>
            <br>
            <span>La contraseña actual del usuario ha sido invalidada.</span>
            <br><br>
            <button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver</button>
        </template>

    </div>

</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'

import {restUser} from '@/components/mixin/restUser.js'

export default{
    name: 'users-temp-password',
    mixins: [restUser],
    data(){
        return{
            generatedPassword: '',
            submitting: false
        }
    },
    components:{
        Breadcrumb
    },
    computed: {
        routesBread: function(){
          return [
              {name:'Usuarios', path: '/usuarios' },
              {name: this.user.firstname + ' ' + this.user.lastname, path: '/usuarios/' + this.$route.params.idUser},
              {name: 'Contraseña temporal'}
              ]
        }
    },
    props: [],
    methods:{
        onClickGoBack: function() {
            this.$router.push('/usuarios/' + this.$route.params.idUser)
        },
        generateTempPassword: function() {
            var that = this;
            that.submitting = true;
            this.$http.post(this.$store.getters.backendurl + 'api/v1/users/' + this.$route.params.idUser + '/temp-password')
            .then(function (response) {
                that.generatedPassword = response.data.password;
                that.submitting = false;
            })
            .catch(function (error) {
                console.log(error)
                that.submitting = false;
                var msg = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Error al crear contraseña temporal';
                that.$store.dispatch('toast/show', { message: msg, type: 'error' });
            });
        },
        copyToClipboard: function() {
            var that = this;
            navigator.clipboard.writeText(this.generatedPassword)
            .then(function () {
                that.$store.dispatch('toast/show', { message: 'Contraseña copiada', type: 'info' });
            })
            .catch(function () {
                that.$store.dispatch('toast/show', { message: 'No se pudo copiar', type: 'error' });
            });
        }
    },
    created () {
        this.$store.getters.getPermissions.users? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getUser();
    }
}
</script>

<style lang="scss" scoped>
.temp-password-row {
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 12px;
    background: #f4f4f4;
    border-radius: 4px;
    max-width: 540px;
}
.temp-password-code {
    flex: 1;
    font-size: 1.15em;
    letter-spacing: 0.04em;
    font-family: monospace;
}
</style>
